export function stringifyServiceSubscriptionNode(node: IServiceSubscription) {
  return JSON.stringify({
    serviceCode: node.service.groupCode,
    accountCode: node.account.code
  })
}